module.exports = __webpack_public_path__ + "img/copy-icon.5b5538c3.svg";